import {CursorBasedPaginationResponse, QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';

export interface NotificationModel {
    id: string;
    active: boolean;
    title: string;
    userId?: string;
    tenantId?: string;
    tokens?: string;
    createdDate: string;
    user: string;
    uniqueId?: string;
    status?: string;
    url?: string;
    order: number;
    type: NotificationTypeEnum;
    data?: string;
}

export enum NotificationTypeEnum {
    FIREBASE = 'FIREBASE',
    NONE = 'NONE',
}

export interface NotificationCreateInputModel extends Omit<NotificationModel, 'id' | 'active' | 'order'> {}

export interface NotificationGetAllRequest extends QueryBaseTypeWithCursorPaginationWhereAndOrder<NotificationModel> {}

export interface NotificationPaginationResponse {
    notifications: CursorBasedPaginationResponse<NotificationModel>;
}

export interface NotificationPayLoad {
    message: string;
    level: 'info' | 'success' | 'warning' | 'error';
    actionKey?: string; // e.g. "confirmBooking"
    actionParams?: string; //Record<string, any> // e.g. JSON.stringify({ bookingId: 123 })
    actionLabel?: string;
    actionUrl?: string; // e.g. "https://example.com"
}

export enum NotificationStatus {
    NONE = 'None',
    READ = 'READ',
    UNREAD = 'Unread',
    DELETED = 'Deleted',
    ARCHIVED = 'Archived',
    SENT = 'Sent',
    FAILED = 'Failed',
    PENDING = 'Pending',
}
